import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

export type Database = {
  public: {
    Tables: {
      recipes: {
        Row: {
          id: string
          title: string
          description: string | null
          ingredients: string[]
          instructions: string[]
          prep_time: number | null
          cook_time: number | null
          servings: number | null
          difficulty: 'gemakkelijk' | 'middel' | 'moeilijk' | null
          tags: string[]
          equipment: string[]
          image_url: string | null
          created_at: string
          updated_at: string
          rating: number | null
          notes: string | null
          user_id: string
        }
        Insert: {
          id?: string
          title: string
          description?: string | null
          ingredients: string[]
          instructions: string[]
          prep_time?: number | null
          cook_time?: number | null
          servings?: number | null
          difficulty?: 'gemakkelijk' | 'middel' | 'moeilijk' | null
          tags?: string[]
          equipment?: string[]
          image_url?: string | null
          created_at?: string
          updated_at?: string
          rating?: number | null
          notes?: string | null
          user_id: string
        }
        Update: {
          id?: string
          title?: string
          description?: string | null
          ingredients?: string[]
          instructions?: string[]
          prep_time?: number | null
          cook_time?: number | null
          servings?: number | null
          difficulty?: 'gemakkelijk' | 'middel' | 'moeilijk' | null
          tags?: string[]
          equipment?: string[]
          image_url?: string | null
          created_at?: string
          updated_at?: string
          rating?: number | null
          notes?: string | null
          user_id?: string
        }
      }
    }
  }
}
